import Image from "next/image";
import React, { useState, useEffect, FC } from "react";
import styles from "./EligibilityContainer.module.css";
import EligibilityFormCard from "../EligibilityForm/EligibilityFormCard";
import EligibilityPricingContainer from "../EligibilityPriceCard/EligibilityPricingContainer";
import EligibilityRecommendedProgram from "../EligibilityRecommendedProgram/EligibilityRecommendedProgram";

interface FormData {
  Programme_Of_Interest: string;
  email: string;
  name: string;
  phone: string;
  qualification: string;
}

interface EligibilityContainerProps {
  formData: FormData | null;
  programsList: any;
  step: any;
}

const EligibilityContainer: FC<EligibilityContainerProps> = ({
  formData,
  programsList,
  step,
}) => {
  const [currentStep, setCurrentStep] = useState<number>(step);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState<any>(null);
  const [selectedNQF, setSelectedNQF] = useState<string | null>(null);
  const [selectedQuestionsAnswer, setSelectedQuestionsAnswer] = useState<
    boolean | null
  >(null);
  const [programSelected, setProgramSelected] = useState(false);
  const [eligibilityFormData, setEligibilityFormData] = useState<any>(null);
  const [windowHeight, setWindowHeight] = useState(0);

  useEffect(() => {
    setCurrentStep(step);
  }, [step]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setWindowHeight(window.innerHeight);
      };

      handleResize();
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  useEffect(() => {
    const savedState = localStorage.getItem("FinalSelectedProgram");
    if (savedState) {
      const state = JSON.parse(savedState);
      setSelectedProgram(state.selectedProgram);
      setEligibilityFormData(state.eligibilityFormData);
    }
  }, []);

  useEffect(() => {
    const state = {
      selectedProgram,
      eligibilityFormData,
    };
    localStorage.setItem("FinalSelectedProgram", JSON.stringify(state));
  }, [selectedProgram, eligibilityFormData]);

  useEffect(() => {
    const savedState = localStorage.getItem("eligibilityState");
    if (savedState) {
      const state = JSON.parse(savedState);
      setFormSubmitted(state.formSubmitted);
      setSelectedProgram(state.selectedProgram);
      setSelectedNQF(state.selectedNQF);
      setSelectedQuestionsAnswer(state.selectedQuestionsAnswer);
      setProgramSelected(state.programSelected);
      setEligibilityFormData(state.eligibilityFormData);
    }
  }, []);

  useEffect(() => {
    const state = {
      formSubmitted,
      selectedProgram,
      selectedNQF,
      selectedQuestionsAnswer,
      programSelected,
      eligibilityFormData,
    };
    localStorage.setItem("eligibilityState", JSON.stringify(state));
  }, [
    formSubmitted,
    selectedProgram,
    selectedNQF,
    selectedQuestionsAnswer,
    programSelected,
    eligibilityFormData,
  ]);

  const handleBack = () => {
    setCurrentStep((prevStep) => Math.max(prevStep - 1, 1));
  };

  const handleFormSubmit = (data: {
    selectedProgram: any;
    selectedNQF: string | null;
    selectedQuestions: any;
    eligibilityFormData: any;
  }) => {
    setFormSubmitted(true);
    setSelectedProgram(data.selectedProgram);
    setSelectedNQF(data.selectedNQF);
    setSelectedQuestionsAnswer(data.selectedQuestions);
    setCurrentStep(2);
    setEligibilityFormData(data.eligibilityFormData);
  };

  return (
    <div className={styles.FormContainer}>
      <div className={styles.ImageContainer}>
        <Image
          src={"/assets/PoupImages/popup-img-desktop.png"}
          alt="Popup Image"
          title="Popup Image"
          className={styles.Image}
          width={400}
          height={580}
          layout="responsive"
          style={{
            objectFit: "cover",
          }}
          loading="eager"
          priority
        />
      </div>
      <div className={styles.contentContainer}>
        {currentStep === 1 && (
          <EligibilityFormCard
            programsList={programsList}
            formData={formData}
            onFormSubmit={handleFormSubmit}
            windowHeight={windowHeight}
          />
        )}

        {currentStep === 2 &&
          selectedProgram &&
          selectedQuestionsAnswer === true && (
            <EligibilityPricingContainer
              selectedProgram={selectedProgram}
              onBack={handleBack}
              eligibilityFormData={eligibilityFormData}
              windowHeight={windowHeight}
            />
          )}

        {currentStep === 2 &&
          selectedQuestionsAnswer === false &&
          selectedNQF !== null &&
          !programSelected && (
            <EligibilityRecommendedProgram
              selectedProgramField={selectedProgram}
              programsList={programsList}
              nqtLevel={selectedNQF}
              onBack={handleBack}
              windowHeight={windowHeight}
            />
          )}
      </div>
    </div>
  );
};

export default EligibilityContainer;
